module.exports = __webpack_public_path__ + "static/img/wanted6.a0275c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/wanted6.png
// module id = E0PM
// module chunks = 1 3